import { Industry } from '../types';
import { Language } from '../i18n/translations';

export const getIndustries = (language: Language): Industry[] => {
  const industryData = {
    en: [
      {
        id: 'marketing',
        name: 'Marketing Agency',
        icon: '📊',
        pains: ['Client Onboarding', 'Weekly Reporting', 'Lead Qualification', 'Content Scheduling', 'Campaign Analytics']
      },
      {
        id: 'realestate',
        name: 'Real Estate',
        icon: '🏠',
        pains: ['Property Listings', 'Client Follow-ups', 'Document Management', 'Showing Coordination', 'Market Reports']
      },
      {
        id: 'ecommerce',
        name: 'E-commerce',
        icon: '🛒',
        pains: ['Inventory Management', 'Order Processing', 'Customer Support', 'Product Updates', 'Shipping Notifications']
      },
      {
        id: 'consulting',
        name: 'Consulting',
        icon: '💼',
        pains: ['Client Discovery', 'Proposal Generation', 'Time Tracking', 'Invoice Processing', 'Research Compilation']
      },
      {
        id: 'healthcare',
        name: 'Healthcare',
        icon: '⚕️',
        pains: ['Appointment Scheduling', 'Patient Reminders', 'Record Management', 'Insurance Verification', 'Billing']
      },
      {
        id: 'legal',
        name: 'Legal Services',
        icon: '⚖️',
        pains: ['Document Review', 'Case Management', 'Client Communication', 'Billing Hours', 'Compliance Tracking']
      },
      {
        id: 'saas',
        name: 'SaaS Company',
        icon: '💻',
        pains: ['User Onboarding', 'Support Tickets', 'Feature Requests', 'Usage Analytics', 'Subscription Management']
      },
      {
        id: 'manufacturing',
        name: 'Manufacturing',
        icon: '🏭',
        pains: ['Inventory Tracking', 'Quality Control', 'Production Reports', 'Supplier Orders', 'Maintenance Logs']
      }
    ],
    es: [
      {
        id: 'marketing',
        name: 'Agencia de Marketing',
        icon: '📊',
        pains: ['Integración de Clientes', 'Reportes Semanales', 'Calificación de Leads', 'Programación de Contenido', 'Analíticas de Campañas']
      },
      {
        id: 'realestate',
        name: 'Bienes Raíces',
        icon: '🏠',
        pains: ['Listados de Propiedades', 'Seguimiento de Clientes', 'Gestión de Documentos', 'Coordinación de Visitas', 'Reportes de Mercado']
      },
      {
        id: 'ecommerce',
        name: 'Comercio Electrónico',
        icon: '🛒',
        pains: ['Gestión de Inventario', 'Procesamiento de Pedidos', 'Atención al Cliente', 'Actualizaciones de Productos', 'Notificaciones de Envío']
      },
      {
        id: 'consulting',
        name: 'Consultoría',
        icon: '💼',
        pains: ['Descubrimiento de Cliente', 'Generación de Propuestas', 'Seguimiento de Tiempo', 'Procesamiento de Facturas', 'Compilación de Investigación']
      },
      {
        id: 'healthcare',
        name: 'Salud',
        icon: '⚕️',
        pains: ['Programación de Citas', 'Recordatorios a Pacientes', 'Gestión de Registros', 'Verificación de Seguros', 'Facturación']
      },
      {
        id: 'legal',
        name: 'Servicios Legales',
        icon: '⚖️',
        pains: ['Revisión de Documentos', 'Gestión de Casos', 'Comunicación con Clientes', 'Horas de Facturación', 'Seguimiento de Cumplimiento']
      },
      {
        id: 'saas',
        name: 'Compañía SaaS',
        icon: '💻',
        pains: ['Integración de Usuarios', 'Tickets de Soporte', 'Solicitudes de Funciones', 'Analíticas de Uso', 'Gestión de Suscripciones']
      },
      {
        id: 'manufacturing',
        name: 'Manufactura',
        icon: '🏭',
        pains: ['Seguimiento de Inventario', 'Control de Calidad', 'Reportes de Producción', 'Órdenes a Proveedores', 'Registros de Mantenimiento']
      }
    ]
  };

  return industryData[language];
};
